<script>
    import PrimaryButton from '@/components/client/Buttons/PrimaryButton';
    import SecondaryButton from '@/components/client/Buttons/SecondaryButton';
    export default {
        props: {
            data: Object,
            company: Object,
        },
        components: { SecondaryButton, PrimaryButton },
        data() {
            return {
                previewCreated: false,
                previewLoaded: false,
                preview: {},
            }
        },
        methods: {
            iframeLoaded() {
                this.previewLoaded = true;
            },
            createPreview() {
                setTimeout(() => {
                    axios.post(`/kund/${this.company.slug}/foretags-sida/create-preview`, {
                        previewData: this.data,
                    }).then(response => {
                        this.previewCreated = true;
                        this.preview = response.data;
                    }).catch(error => {});
                }, 500);
            },
            setDeviceView(viewport) {
                const viewPorts = {
                    mobile: { width: '400px', },
                    tablet: { width: '767px', },
                    desktop: { width: '100%', },
                };

                this.$refs.iframe.width = viewPorts[viewport].width;
            }
        }
    }
</script>

<template>
    <div>
        <div v-if="!previewLoaded" class="flex flex-col justify-center items-center min-h-screen">
            <i class="fas fa-spin fa-spinner fa-atom text-5xl text-gray"></i>
            <div class="text-gray font-avertaLight mt-3 text-2xl">Förhandsgranskningen startar</div>
        </div>

        <div v-if="previewCreated && previewLoaded" class="bg-blue flex px-4 py-2">
            <div>
                <secondary-button @click="setDeviceView('mobile')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                </secondary-button>

                <secondary-button @click="setDeviceView('tablet')" class="ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 18h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z" />
                    </svg>
                </secondary-button>

                <secondary-button @click="setDeviceView('desktop')" class="ml-2">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                </secondary-button>
            </div>

            <div class="ml-auto flex">
                <primary-button @click="$emit('close')">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </primary-button>
            </div>
        </div>

        <div class="flex justify-center">
            <iframe
                v-if="previewCreated"
                ref="iframe"
                width="100%"
                :onload="iframeLoaded"
                :src="`${preview.url}?previewKey=${preview.key}`"
                style="transition: opacity 0.5s ease-in-out, width .5s;min-height: 100vh;"/>
        </div>
    </div>
</template>
